// extracted by mini-css-extract-plugin
export default {"myLocationDot":"KakaoMapEVStation_myLocationDot__kdXg+","myLocationShadow":"KakaoMapEVStation_myLocationShadow__IGpJR","flickerAnimation":"KakaoMapEVStation_flickerAnimation__wAShx"};